module.exports = __webpack_public_path__ + "media/assets/good_at/react-c78dcc1530f7132397e1b85b8431b0e8.png";